module.exports = __webpack_public_path__ + "img/img_03@2x.4a5729f7.png";